import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function AppHeader({ title, subtitle, right, backTo }) {
    const nav = useNavigate();

    const handleBack = () => {
        if (backTo) nav(backTo);
    };

    return (
        <header className="app-header" role="banner">
            <div className="app-header-slot app-header-left">
                {backTo ? (
                    <button
                        className="app-header-back"
                        type="button"
                        onClick={handleBack}
                        aria-label="Back"
                    >
                        <ChevronLeft size={20} aria-hidden="true" />
                    </button>
                ) : (
                    <span className="app-header-spacer" aria-hidden="true" />
                )}
            </div>

            <div className="app-header-center">
                <h1 className="app-header-title">{title}</h1>
                {subtitle ? <p className="app-header-subtitle">{subtitle}</p> : null}
            </div>

            <div className="app-header-slot app-header-right">
                {right ? right : <span className="app-header-spacer" aria-hidden="true" />}
            </div>
        </header>
    );
}
